import { configureStore } from '@reduxjs/toolkit'
import userAgreementSlice from './slice/userAgreementSlice'

export const store = configureStore({
  reducer: {
    userAgreement: userAgreementSlice
  },
})